import type {BirthdayFormat} from '@FormMakerReact/form-maker.types';
import {BIRTHDAY_FORMATS} from '@FormMakerReact/form-maker.types';

export const BIRTHDAY_FORMAT_OPTIONS: readonly {value: BirthdayFormat; labelKey: string}[] = [
  {value: BIRTHDAY_FORMATS.DMY, labelKey: 'pmwjs_format_dmy'},
  {value: BIRTHDAY_FORMATS.MDY, labelKey: 'pmwjs_format_mdy'},
  {value: BIRTHDAY_FORMATS.YMD, labelKey: 'pmwjs_format_ymd'},
];

/**
 * - 'birthday': Required checkbox + format dropdown.
 * - 'custom':   Required checkbox + label text input.
 * - 'standard': Required checkbox only.
 */
export type FieldEditRowKind = 'birthday' | 'custom' | 'standard';

export interface FieldEditRowProps {
  /** Stable per-row id; needed so multiple rows render unique label htmlFor targets. */
  rowId: string;
  kind: FieldEditRowKind;
  labelValue: string;
  birthdayFormat: BirthdayFormat;
  isRequired: boolean;
  /** Drives the max-height + opacity transition; panel stays mounted across collapse/expand. */
  isOpen: boolean;
  onLabelChange: (newLabel: string) => void;
  onFormatChange: (newFormat: BirthdayFormat) => void;
  onRequiredChange: (isRequired: boolean) => void;
}
